export const MAIN_NAV_LINKS = [
  { to: '/events', label: 'Browse events' },
  { to: '/categories', label: 'Categories' },
  { to: '/about', label: 'About' }
];

export const SOCIAL_LINKS = [
  { href: 'https://facebook.com', label: 'Facebook', icon: 'fab fa-facebook-f' },
  { href: 'https://twitter.com', label: 'X (Twitter)', icon: 'fab fa-x-twitter' },
  { href: 'https://instagram.com', label: 'Instagram', icon: 'fab fa-instagram' },
  { href: 'https://tiktok.com', label: 'TikTok', icon: 'fab fa-tiktok' }
];

export const SUPPORT_EMAIL = 'info@nikovibe.com';
export const SUPPORT_INBOX_EMAIL = 'support@nikovibe.com';
export const SUPPORT_PHONE = '+254 140 679730';
export const SUPPORT_PHONE_RAW = '254140679730';
export const HELP_CENTER_PATH = '/help';
export const CONTACT_PATH = '/contact';

export const TOP_BAR_LINKS = [
  { to: HELP_CENTER_PATH, label: 'Help Center' },
  { to: CONTACT_PATH, label: 'Contact Us' }
];

export const SUPPORT_SUB_NAV = [
  { to: '/help', label: 'Help Center' },
  { to: '/help', label: 'Help', hash: '#getting-started' },
  { to: '/contact', label: 'Contact Us' }
];

export const WHATSAPP_DEFAULT_MESSAGE = 'Hello Niko Vibe team, I need help with: ';

export function getWhatsAppUrl(message = WHATSAPP_DEFAULT_MESSAGE) {
  return `https://wa.me/${SUPPORT_PHONE_RAW}?text=${encodeURIComponent(message)}`;
}

export function getListEventPath(user) {
  if (!user) return '/login';
  if (['ADMIN', 'SUPER_ADMIN', 'ORGANIZER'].includes(user.role)) {
    return '/admin/events/create';
  }
  return '/about';
}

export function getDashboardPath(user) {
  if (!user) return '/login';
  if (['ADMIN', 'SUPER_ADMIN'].includes(user.role)) return '/admin/dashboard';
  if (user.role === 'ORGANIZER' || user.role === 'ORGANIZER_STAFF') return '/admin/sales';
  return '/dashboard';
}
